import * as React from 'react'
import AutoSizer from 'react-virtualized-auto-sizer'

import { Box, Text, colors, dimensions } from '@factorialco/deprecated-design-system'
import { Bar } from '@nivo/bar'
import { compact } from 'lodash'

import i18n from 'modules/core/lib/i18n'

interface Props {
  data: Array<{
    employees: number
    level: string
    order: number
  }>
}

type BarDatum = {
  employees: number
  level: string
  order: number
}

type BarTooltipProps = {
  data: BarDatum
}

const SalaryGenderBar: React.FC<Props> = ({ data }) => {
  const employees = data.map((a) => a.employees)
  const maxYaxis = employees && Math.max(...employees)

  const populatedLevels = data.filter((x) => x.employees > 0)
  const CustomTooltip = (e: BarTooltipProps) => {
    const levelName = e.data.level
    return (
      <Box
        borderRadius={{
          all: 'abs008',
        }}
        padding="s8"
        style={{
          background: colors.darker800,
        }}
        width="full"
      >
        <Text.Normal color="grey000White">{levelName}</Text.Normal>
        <Box alignItems="center" paddingTop="s12" gap="s8" flexDirection="row">
          <Box
            borderRadius={{
              all: 'rel1000',
            }}
            style={{ background: colors.purple1000, height: dimensions.s16, width: dimensions.s16 }}
          />
          <Text.Normal weight="medium" color="grey000White">
            {i18n.t('job_catalog.salary_insights_tooltip.employees')}
          </Text.Normal>
          <Box paddingLeft="s16">
            <Text.Normal weight="medium" color="grey000White">
              {e.data.employees}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box height="s400" width="full">
      <AutoSizer>
        {({ height, width }: { height: number; width: number }) => (
          <Bar
            height={height}
            width={width}
            margin={{ right: 30, left: 1, bottom: 24, top: 24 }}
            indexBy="level"
            keys={['employees']}
            data={compact(populatedLevels)}
            colors={colors.purple1000}
            axisBottom={null}
            maxValue={maxYaxis + 1}
            enableGridX
            axisRight={{
              tickRotation: 0,
              legendOffset: 60,
              format: (e) => Math.floor(e) === e && e,
            }}
            theme={{
              axis: {
                ticks: {
                  line: {
                    strokeWidth: 0,
                  },
                  text: {
                    color: colors.grey800,
                    fontSize: dimensions.s12,
                    outlineWidth: 2,
                  },
                },
              },
              grid: {
                line: {
                  stroke: colors.grey400,
                  strokeWidth: dimensions.s2,
                  strokeDasharray: '4 4',
                },
              },
            }}
            tooltip={CustomTooltip}
            padding={0.5}
            axisLeft={null}
            enableLabel={false}
          />
        )}
      </AutoSizer>
    </Box>
  )
}

export default SalaryGenderBar
